enum FootTrafficFilterApi {
  Omnichannel = 'onmichannel',
  Youtube = 'youtube',
  Audio = 'audio',
  // Dooh = 'dooh',
}

export default FootTrafficFilterApi;
